import {Component, OnInit, ViewChild} from '@angular/core';
import {ResourcesService} from '../../services/resources.service';
import {ResourceArticle, ResourceHistory} from '../../model/resource';

import {FaIconComponent} from "@fortawesome/angular-fontawesome";
import {ResourcesTreeComponent} from "./resources-tree/resources-tree.component";
import {PdfJsViewerModule} from "ng2-pdfjs-viewer";
import {BreadcrumbComponent} from "../../components/common/breadcrumb/breadcrumb.component";
import {SearchBarComponent} from "../../components/common/search-bar/search-bar.component";
import {MarkjsHighlightDirective} from "../../directives/markjsHighlight.directive";
import {SearchPipe} from "../../components/common/SearchPipe";
import { SpinnerComponent } from 'src/app/components/common/spinner/spinner.component';

@Component({
    selector: 'app-resources',
    imports: [
    FaIconComponent,
    ResourcesTreeComponent,
    PdfJsViewerModule,
    SpinnerComponent,
    BreadcrumbComponent,
    SearchBarComponent,
    MarkjsHighlightDirective,
    SearchPipe
],
    templateUrl: './resources.component.html',
    styleUrls: ['./resources.component.css']
})
export class ResourcesComponent implements OnInit {
  @ViewChild('pdfViewer') public pdfViewer;

  resources: ResourceArticle[];
  history: ResourceHistory[];
  $showall = undefined;
  $hideall = undefined;
  showPdf = false;
  loadingPdf = false;
  search = "";

  constructor(private resourcesService: ResourcesService) {
  }

  ngOnInit(): void {
    this.resourcesService.listResources().subscribe(r => {
      this.resourcesService.history().subscribe(history => {
        // Create history object from docid and date
        const historyData = Object.fromEntries(history.map(obj => [obj.docid, obj.date]));
        // Go throught each resource, and set read tag from history
        this.resources = r.map(obj => {
          obj.read = obj.id in historyData ? new Date(historyData[obj.id]) > new Date(obj.changed) : false;
          return obj;
        });
      });
    });
  }

  showAll(): void {
    this.$showall = true;
    setTimeout(() => {
      this.$showall = undefined;
    });
  }

  hideAll(): void {
    this.$hideall = true;
    setTimeout(() => {
      this.$hideall = undefined;
    });
  }

  onPdfLoading(isLoading: boolean): void {
    this.loadingPdf = isLoading;
  }

  selectFile($event: { blob: Blob, filename: string }): void {
    if ($event.blob === null) {
      this.showPdf = false;
    } else {
      this.loadingPdf = false;
      this.showPdf = true;
      this.pdfViewer.downloadFileName = $event.filename;
      this.pdfViewer.pdfSrc = $event.blob;
      this.pdfViewer.refresh();
    }
  }
}
